import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ScratchpadContext } from "contexts/ScratchpadProvider";
import NavIcon from "components/navigation/NavIcon";
import NavigationButton from "components/navigation/NavigationButton";
const ScratchpadToggle = () => {
  const { t } = useTranslation("navigation");
  const { toggleScratchpadVisibility } = useContext(ScratchpadContext);
  return /* @__PURE__ */ React.createElement("li", { role: "presentation" }, /* @__PURE__ */ React.createElement(NavigationButton, { "aria-label": t("shell.scratchpad"), id: "scratchpad-toggle", onClick: toggleScratchpadVisibility }, /* @__PURE__ */ React.createElement(NavIcon, { type: "scratchpad", title: t("shell.scratchpad") })));
};
export default ScratchpadToggle;
